import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const assetsDataManagerObjectClassesSettingsRoute: InvariantJiraRoute = {
	name: 'assets-data-manager-object-classes-settings',
	path: '/jira/assets/data-manager/object-classes/settings/:settingType(data-source-type|data-source-priorities|attribute-priorities|default-cleansing-rules|cleansing-categories|custom-date-formats|audit-log)',
	exact: true,
};
